import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import LanguageSelection from './pages/LanguageSelection';
import LandingPage from './pages/LandingPage';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <HashRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<LanguageSelection />} />
            <Route path="/en" element={<LandingPage />} />
            <Route path="/es" element={<LandingPage />} />
            {/* Redirect any unknown paths back to the language selection */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </LanguageProvider>
      </HashRouter>
    </ErrorBoundary>
  );
}

export default App;